export default {
      id: "sli-refresh-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.43681d49.svg#sli-refresh",
      toString: function () {
        return this.url;
      }
    }